import { WappMode } from '@weblite-wapps/protocol'
import { wappView } from '../wapprunner-pool/wapprunnerPool.reducer'

export const sendWappLoadingTimeAnalytics = ({
  wappSessionId,
  duration,
}: {
  wappSessionId: string
  duration: number
}) => {
  const { wappId, wisId } = wappView(wappSessionId)
  analite('WAPP_LOAD', { d: duration, wi: wappId, si: wisId })
}

export const sendWappRunningTimeAnalytics = ({
  wappSessionId,
  duration,
}: {
  wappSessionId: string
  duration: number
}) => {
  const { wappId, wisId, mode } = wappView(wappSessionId)
  const durationInSeconds = Math.round(duration / 1000)
  const minifiedMode = mode?.[0].toUpperCase()

  if (mode !== WappMode.INLINE || durationInSeconds >= 3)
    analite('WAPP_TIME', {
      d: durationInSeconds,
      wi: wappId,
      si: wisId,
      m: minifiedMode,
    })
}
